/**
 * GSW Tabbed Content Component
 * Accessible tab component with keyboard navigation
 */
(function() {
  'use strict';

  class GswTabbedContent {
    constructor(container) {
      this.container = container;
      this.tabs = Array.from(container.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

      if (this.tabs.length === 0) return;

      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchTab(tab);
        });

        tab.addEventListener('keydown', (e) => this.handleKeydown(e, tab));
      });
    }

    switchTab(selectedTab) {
      const targetId = selectedTab.getAttribute('aria-controls');

      // Update tab states
      this.tabs.forEach(tab => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', isSelected);
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      // Update panel visibility
      this.panels.forEach(panel => {
        const isActive = panel.id === targetId;
        panel.setAttribute('aria-hidden', !isActive);
      });
    }

    handleKeydown(e, currentTab) {
      const currentIndex = this.tabs.indexOf(currentTab);
      let newIndex;

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          newIndex = currentIndex > 0 ? currentIndex - 1 : this.tabs.length - 1;
          break;
        case 'ArrowRight':
          e.preventDefault();
          newIndex = currentIndex < this.tabs.length - 1 ? currentIndex + 1 : 0;
          break;
        case 'Home':
          e.preventDefault();
          newIndex = 0;
          break;
        case 'End':
          e.preventDefault();
          newIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      if (newIndex !== undefined) {
        this.tabs[newIndex].focus();
        this.switchTab(this.tabs[newIndex]);
      }
    }
  }

  function initTabbedContent() {
    const containers = document.querySelectorAll('[data-gsw-tabbed-content]');
    containers.forEach(container => new GswTabbedContent(container));
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabbedContent);
  } else {
    initTabbedContent();
  }

  // Re-initialize on Shopify section events (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTabbedContent);
  }
})();
